import React, { Component } from 'react'
import moment from "moment";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
import service from "../../../services";
import MainLayout from '../../../mainLayout/index';

import UserImage from "./../../../assets/images/user.jpg";
import Loader from "../../loader";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import ShowPasswordIcon from '../../../icons/ShowPassIcon';
import ReactPaginate from "react-paginate";
import ViewIcon from '../../../icons/viewIcon';
import TextField from '../../TextField'
import CopyToClipboard from "copy-to-clipboard";
let sub;
let statusFilterList = []
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class shortProgramEpisodicList extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          isExist:true,
          filmAccessData:'',
          filmAccessDate:'',
          userEmail:'',
          showPass:false,
          password:'',
          pin:'',
          exploreShortProgramList: [],
          loaderFlag: false,
          offset: 0,
          perPage: 50,
          currentPage: 0,
          date: [],
          statusArray: [
            { assign: "Live", list: 1, value: false },
            { assign: "Disable", list: 2, value: false },
          ],
        };
        this.apiserve = new service();
      }
    
    componentWillUnmount = () => {
       sub.unsubscribe();
       statusFilterList = [];
    };
    
     componentDidMount = () => {
      let currentPage = localStorage.getItem('currentPage')
      if(currentPage) {
      this.setState({
        offset: parseInt(localStorage.getItem("offset")),
        perPage: parseInt(localStorage.getItem("perPage")),
        currentPage: parseInt(localStorage.getItem("currentPage")),
      },() =>
          this.getShortProgramList(this.state.offset, this.state.perPage)
      );
      }else{
              this.setState({
          offset:0,
          perPage:50,
          currentPage:0
      },() =>
          this.getShortProgramList(this.state.offset, this.state.perPage))
      }
      
        sub = this.apiserve.getevent().subscribe((response) => {
          switch (response.event) {
            case "fpg|shortProgramme|getList":
                if(!response.error){
                    this.setState({
                        ShortProgramList:response.data && response.data.docs,
                        pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                        loaderFlag: false,
                    })
                }
             
              break;
              case "fpg|screenerCredential|addPassword":
                if(!response.error){
                    this.setState({
                        screenmodal: false,
                        password:''
                    })
                }else{
                    this.apiserve.error(response.error.data ? response.error.data : response.error )
                }
                
                break;
                case "user|checkStatus":
                  if(!response.error){
                      this.setState({
                          isExist:response.data.isExist,
                          userEmail:response?.data?.user
                      })
                  }else{
                      this.apiserve.error(response.data.error ? response.data.error : response.data)
                  }
                  break;
                  case "admin|screening|getMasterLink":
                  if(!response.error){
                      this.setState({
                         linkCopy:response?.data?.link
                      })
                  }else{
                      this.apiserve.error(response.data.error ? response.data.error : response.data)
                  }
                  break;
              
            default:
              break;
          }
        });
    };

    getShortProgramList = (skip, limit) => {
        this.setState({
          loaderFlag: true
      })
        var data = {
          page: skip,
          limit: limit,
          programType:'2'
        };

        if (statusFilterList && statusFilterList.length) {
            data.status = statusFilterList;
          }
        this.apiserve.sendevent("fpg|shortProgramme|getList", data);
      };

      handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
          {
            currentPage: selectedPage,
            offset: offset,
            loaderFlag: true,
          },
          () => {
            localStorage.setItem('currentPage',this.state.currentPage)
            localStorage.setItem('offset',offset)
            localStorage.setItem('perPage',this.state.perPage)
            this.getShortProgramList(offset, this.state.perPage);
          }
        );
      };

      StatusFilter = (e, selectedInex, isClearStatusType = false) => {
        let index = selectedInex;
        let event = e && e.target && e.target.checked;
        let approvePassList = [...this.state.statusArray];
        approvePassList.forEach((key, i) => {
          if (i === index) {
            approvePassList[i].value = event;
          }
          if (isClearStatusType) {
            approvePassList[i].value = false;
            statusFilterList = [];
          }
        });
        this.setState(
          {
            ...this.state,
            statusArray: approvePassList,
            currentPage: 0,
          },
          () => {
            if (event) {
              if (index !== null) {
                statusFilterList = [
                  ...statusFilterList,
                  this.state.statusArray[index].list,
                ];
              }
            } else {
              if (index !== null) {
                let tempArray = statusFilterList.filter(
                  (d) => d !== this.state.statusArray[index].list
                );
                statusFilterList = tempArray;
              }
            }
            this.getFilmFilter(
              this.state.offset,
              this.state.perPage,
              isClearStatusType
            );
          }
        );
      };
    
      getFilmFilter = (skip, limit, isClearStatusType) => {
        let data = {
          page: 1,
          limit: limit,
          programType:'2'
        };
    
        if (!isClearStatusType && statusFilterList && statusFilterList.length) {
          data.status = statusFilterList;
        }
    
        this.apiserve.sendevent("fpg|shortProgramme|getList", data);
      };

      editShortProgramList = (item) => {
        this.props.EpisodicShortProgramEditData(item)
        this.props.history.push({
          pathname: "/episodic-program-view",
        });
      };
    
    ScreenerPopup = (e,data,filmData) => {
      e.stopPropagation();
      this.setState({
          screenmodal:true,
          ScreenerPopupData:data,
          ScreenerPopupFilmData:filmData
      })
    }

    scannerLogin = (e,date,item) => {
      e.stopPropagation();
      e.preventDefault();
      let data = {}
      data.film = date._id
      data.filmType = 'ShortProgramme'
      let scannerLogin = this.apiserve.encrypt(data)
      window.open(process.env.REACT_APP_FRONTEND_ORIGIN_CMS + 'moderator/signin?data=' + scannerLogin);

      // this.props.history.push('/screening-signin')
    }

    scannerSave = (date,data) => {
      const isValid = this.validate()
      if (isValid) {
      var data = {
          "filmId": data._id,
          "date": date._id,
          "filmType": "ShortProgramme",
          "password": this.state.password
      }
      this.apiserve.sendevent("fpg|screenerCredential|addPassword",data);
    }
    }

  validate = () => {
    let passwordErr = '';
    if (!this.state.password) {
        passwordErr = 'Password can not be blank'
    }
    else {
        if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
            passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
        }
    }

    this.setState({
        passwordErr
    })
    if (passwordErr) {
        return false
    }
    return true
  }

  onInputChange = (e) => {
    const {name,value} = e.target
    this.setState({
        [name]:value
    })
  }
    
  Showpassword = () => {
    this.setState({
        showPass: !this.state.showPass
    })
}

ClickAddScreenerPopup = (e,item,date) => {
  e.stopPropagation();
  this.setState({
      addScreenerPopup : true,
      filmAccessData: item,
      filmAccessDate:date
  })
}
CloseModal = () => {
  this.setState({
      addScreenerPopup:false
  })
}

  setEmailGo = (e) => {
    e.preventDefault();
    var data = {
      email:this.state.email
    }
    this.apiserve.sendevent("user|checkStatus",data);
  }

  setLink = (e) => {
    e.preventDefault();
    const {email,filmAccessData,filmAccessDate} = this.state
    var data = {
        "film": filmAccessData?._id,
        "filmType": "ShortProgramme",
        "email": email.trim()
      }
      this.apiserve.sendevent("admin|screening|getMasterLink",data);
  }

  copyLink = (e,link) => {
    e.preventDefault();
    CopyToClipboard(link);
    this.apiserve.success('Link Copied!')
  }

  getLocationslist = (locations) => {

    let emptyData = []
  
    locations.map(location => {
      emptyData.push(location.name)
    });
  
    return emptyData.join(', ')
  }
     
    render() {
        const { ShortProgramList, statusArray, ScreenerPopupData,ScreenerPopupFilmTitle,ScreenerPopupFilmData } = this.state;
        return (
            <div className="table_wrap film_list_table striped_table">
              <table className="row_height_tbl">
                <thead>
                  <tr>
                      <th></th>
                    <th>Number of Shorts</th>
                    <th style={{ width: "525px" }}>Date-Time (MT)-Location
                      {/* <span style={{ width: "90px", marginLeft: "165px", display: "inline-block" }}>Screener</span> */}
                    </th>
                    <th></th>
                    {/* {process.env.REACT_APP_FRONTEND_ORIGIN_CMS === 'https://cms.festival.sundance.org/' ? '':
                      <th style={{width:"90px"}}>Screener</th>
                    } */}
                    <th>
                      <span className="d_flex d_flex_align_center">
                        Status
                        {statusFilterList && statusFilterList.length ? (
                          <FilterActiveIcon />
                        ) : (
                          <FilterIcon />
                        )}
                      </span>
                      <div className="tabelData_popup">
                        <form>
                          <div className="customCheck">
                            <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                              <p
                                className="link"
                                onClick={() => this.StatusFilter(null, null, true)}
                              >
                                Clear All
                              </p>
                            </div>

                            <div className="customCheckBox">
                              {statusArray.map((item, i) => (
                                <div className="customCheckBox">
                                  <input
                                    type="checkbox"
                                    id={"status" + item.list}
                                    name={"status" + item.list}
                                    value={item.list ? true : false}
                                    checked={item.value ? true : false}
                                    onClick={(e) => this.StatusFilter(e, i)}
                                  />
                                  <label htmlFor={"status" + item.list}>
                                    {item.assign}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </form>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                {ShortProgramList &&
                  ShortProgramList.length > 0 &&
                  ShortProgramList.map((item) => {
                      var shortDate = new Date(item.date)
                      return(
                        <tr onClick={() => this.editShortProgramList(item._id)} className={`pointer ${item.status === 2 ? 'disable': ''}`}>
                        <td>
                          <div className="disp_flex">
                            <div className="film_desc">
                              <h3>{item.name}</h3>
                            </div>
                          </div>
                        </td>
                      <td>
                      <div className="">
                        {item.filmCount}
                      </div>
                      </td>
                      {/* moment(shortDate).format('MMM DD') */}
                      {/* moment(shortDate).format("h:mm A") */}
                        {/* <td>
                          <div className="d_flex">
                            {
                              item?.dateTime.map((list) => {
                                return (
                                  <p>{moment(list.date).tz("US/Mountain").format('MMM DD - h:mm A')} { list.locationType === undefined || list.locationType === "2" ? '- Online' : list.locations.length > 0 ? ' - ' + this.getLocationslist(list.locations) : ''}</p>
                                )
                              })
                            }
                               <span className="ml_10  pointer" onClick={(e) => this.ClickAddScreenerPopup(e,item)}>
                                 <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                   <path d="M22 13H18V6H22V13ZM23 4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5V15C16 15.2652 16.1054 15.5196 16.2929 15.7071C16.4804 15.8946 16.7348 16 17 16H23C23.2652 16 23.5196 15.8946 23.7071 15.7071C23.8946 15.5196 24 15.2652 24 15V5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4ZM4 2H22V0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V13H0V16H14V13H4V2Z" fill="black"/>
                                </svg>
                              </span>
                          </div>
                          <div>
                        </div>  
                        </td> */}
                         <td>
                          <div>
                            {
                              item.dateTime && item.dateTime.length >= 1 ? 
                              item.dateTime.sort((a, b) => a.date > b.date ? 1 : -1).map((date) => {
                                  return(
                                      <div className="d_flex d_flex_align_center mb_5">
                                          {date.date !== undefined && 
                                          <>
                                              <p className="aa" style={{width:"315px"}}>{moment(date.date).tz("US/Mountain").format('MMM DD - h:mm A')} - {moment(date.endDate).tz("US/Mountain").format('MMM DD - h:mm A')} { date.locationType === undefined || date.locationType === "2" ? '- Online' : date.locations.length > 0 ? ' - ' + this.getLocationslist(date.locations) : ''}</p>
                                                  {/* {date.screeningType === "1" && date.locationType === "2" ?
                                                  <div className="d_flex d_flex_align_center" style={{width:"50px",marginLeft:"20px"}}>
                                                      <span className="mr_10 pointer" onClick={(e) => this.ScreenerPopup(e,date,item)}>
                                                          <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path d="M9.33333 5.33333H3.33333V3.33333C3.33333 2.23067 4.23067 1.33333 5.33333 1.33333C6.436 1.33333 7.33333 2.23067 7.33333 3.33333H8.66667C8.66667 1.49533 7.17133 0 5.33333 0C3.49533 0 2 1.49533 2 3.33333V5.33333H1.33333C0.979711 5.33333 0.640573 5.47381 0.390524 5.72386C0.140476 5.97391 0 6.31305 0 6.66667V12C0 12.3536 0.140476 12.6928 0.390524 12.9428C0.640573 13.1929 0.979711 13.3333 1.33333 13.3333H9.33333C9.68695 13.3333 10.0261 13.1929 10.2761 12.9428C10.5262 12.6928 10.6667 12.3536 10.6667 12V6.66667C10.6667 6.31305 10.5262 5.97391 10.2761 5.72386C10.0261 5.47381 9.68695 5.33333 9.33333 5.33333ZM4.04067 8.99933C4.12261 8.68562 4.31596 8.41247 4.58459 8.23089C4.85321 8.04932 5.17876 7.97174 5.5004 8.01265C5.82205 8.05356 6.11781 8.21016 6.33243 8.4532C6.54705 8.69624 6.66586 9.0091 6.66667 9.33333C6.66628 9.56649 6.60446 9.79544 6.48742 9.9971C6.37038 10.1988 6.20226 10.366 6 10.482V12H4.66667V10.482C4.41441 10.3375 4.21656 10.1141 4.10348 9.8463C3.9904 9.57846 3.96833 9.28092 4.04067 8.99933Z" fill="black" />
                                                          </svg>
                                                      </span>
                                                      <span className="mr_10 pointer" onClick={(e) => this.scannerLogin(e, date, item)}>
                                                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.19997 0.133303C0.91707 0.133303 0.645759 0.245683 0.44572 0.445722C0.245681 0.645761 0.133301 0.917072 0.133301 1.19997V10.8C0.133301 11.0829 0.245681 11.3542 0.44572 11.5542C0.645759 11.7543 0.91707 11.8666 1.19997 11.8666H10.8C11.0829 11.8666 11.3542 11.7543 11.5542 11.5542C11.7543 11.3542 11.8666 11.0829 11.8666 10.8V7.06664C11.8666 6.92519 11.8104 6.78953 11.7104 6.68951C11.6104 6.58949 11.4748 6.5333 11.3333 6.5333C11.1919 6.5333 11.0562 6.58949 10.9562 6.68951C10.8562 6.78953 10.8 6.92519 10.8 7.06664V10.8H1.19997V1.19997H4.9333C5.07475 1.19997 5.21041 1.14378 5.31042 1.04376C5.41044 0.94374 5.46663 0.808085 5.46663 0.666636C5.46663 0.525187 5.41044 0.389532 5.31042 0.289512C5.21041 0.189493 5.07475 0.133303 4.9333 0.133303H1.19997ZM11.7109 0.289036C11.8101 0.388464 11.866 0.523 11.8666 0.663436V3.86664C11.8666 4.00809 11.8104 4.14374 11.7104 4.24376C11.6104 4.34378 11.4748 4.39997 11.3333 4.39997C11.1919 4.39997 11.0562 4.34378 10.9562 4.24376C10.8562 4.14374 10.8 4.00809 10.8 3.86664V1.9541L5.3109 7.44424C5.26131 7.49382 5.20245 7.53316 5.13766 7.55999C5.07287 7.58683 5.00343 7.60064 4.9333 7.60064C4.86317 7.60064 4.79373 7.58683 4.72895 7.55999C4.66416 7.53316 4.60529 7.49382 4.5557 7.44424C4.50611 7.39465 4.46678 7.33578 4.43994 7.27099C4.41311 7.2062 4.39929 7.13676 4.39929 7.06664C4.39929 6.99651 4.41311 6.92707 4.43994 6.86228C4.46678 6.79749 4.50611 6.73862 4.5557 6.68904L10.0458 1.19997H8.1333C7.99185 1.19997 7.8562 1.14378 7.75618 1.04376C7.65616 0.94374 7.59997 0.808085 7.59997 0.666636C7.59997 0.525187 7.65616 0.389532 7.75618 0.289512C7.8562 0.189493 7.99185 0.133303 8.1333 0.133303H11.3333C11.4034 0.133119 11.4728 0.146782 11.5376 0.173507C11.6024 0.200232 11.6613 0.239493 11.7109 0.289036Z" fill="black" />
                                                          </svg>
                                                      </span>
                                                  </div> : <div style={{width:"50px",marginLeft:"20px"}}></div>
                                                }
                          
                                                {
                                                    date.locationType === "2" ?
                                                    <p style={{width:"40px",marginLeft:"30px"}} className="mr_10 pointer" onClick={(e) => this.ClickAddScreenerPopup(e,item,date)}>
                                                        <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M22 13H18V6H22V13ZM23 4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5V15C16 15.2652 16.1054 15.5196 16.2929 15.7071C16.4804 15.8946 16.7348 16 17 16H23C23.2652 16 23.5196 15.8946 23.7071 15.7071C23.8946 15.5196 24 15.2652 24 15V5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4ZM4 2H22V0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V13H0V16H14V13H4V2Z" fill="black"/>
                                                        </svg>
                                                    </p>
                                                    :''
                                                } */}
                                        </>}
                                      </div>
                                  )
                              }) : '-'
                            }
                          </div>
                      </td>
                      <td>  
                         
                      </td>
                      {/* {process.env.REACT_APP_FRONTEND_ORIGIN_CMS === 'https://cms.festival.sundance.org/' ? '':
                       <td>
                      <div className="d_flex ">
                            <span className="mr_10 pointer" onClick={(e) => this.ScreenerPopup(e,item.date,item)}>
                                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.33333 5.33333H3.33333V3.33333C3.33333 2.23067 4.23067 1.33333 5.33333 1.33333C6.436 1.33333 7.33333 2.23067 7.33333 3.33333H8.66667C8.66667 1.49533 7.17133 0 5.33333 0C3.49533 0 2 1.49533 2 3.33333V5.33333H1.33333C0.979711 5.33333 0.640573 5.47381 0.390524 5.72386C0.140476 5.97391 0 6.31305 0 6.66667V12C0 12.3536 0.140476 12.6928 0.390524 12.9428C0.640573 13.1929 0.979711 13.3333 1.33333 13.3333H9.33333C9.68695 13.3333 10.0261 13.1929 10.2761 12.9428C10.5262 12.6928 10.6667 12.3536 10.6667 12V6.66667C10.6667 6.31305 10.5262 5.97391 10.2761 5.72386C10.0261 5.47381 9.68695 5.33333 9.33333 5.33333ZM4.04067 8.99933C4.12261 8.68562 4.31596 8.41247 4.58459 8.23089C4.85321 8.04932 5.17876 7.97174 5.5004 8.01265C5.82205 8.05356 6.11781 8.21016 6.33243 8.4532C6.54705 8.69624 6.66586 9.0091 6.66667 9.33333C6.66628 9.56649 6.60446 9.79544 6.48742 9.9971C6.37038 10.1988 6.20226 10.366 6 10.482V12H4.66667V10.482C4.41441 10.3375 4.21656 10.1141 4.10348 9.8463C3.9904 9.57846 3.96833 9.28092 4.04067 8.99933Z" fill="black"/>
                                </svg>
                            </span>
                            <span className="mr_10 pointer" onClick={(e) => this.scannerLogin(e,item)} >
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.19997 0.133303C0.91707 0.133303 0.645759 0.245683 0.44572 0.445722C0.245681 0.645761 0.133301 0.917072 0.133301 1.19997V10.8C0.133301 11.0829 0.245681 11.3542 0.44572 11.5542C0.645759 11.7543 0.91707 11.8666 1.19997 11.8666H10.8C11.0829 11.8666 11.3542 11.7543 11.5542 11.5542C11.7543 11.3542 11.8666 11.0829 11.8666 10.8V7.06664C11.8666 6.92519 11.8104 6.78953 11.7104 6.68951C11.6104 6.58949 11.4748 6.5333 11.3333 6.5333C11.1919 6.5333 11.0562 6.58949 10.9562 6.68951C10.8562 6.78953 10.8 6.92519 10.8 7.06664V10.8H1.19997V1.19997H4.9333C5.07475 1.19997 5.21041 1.14378 5.31042 1.04376C5.41044 0.94374 5.46663 0.808085 5.46663 0.666636C5.46663 0.525187 5.41044 0.389532 5.31042 0.289512C5.21041 0.189493 5.07475 0.133303 4.9333 0.133303H1.19997ZM11.7109 0.289036C11.8101 0.388464 11.866 0.523 11.8666 0.663436V3.86664C11.8666 4.00809 11.8104 4.14374 11.7104 4.24376C11.6104 4.34378 11.4748 4.39997 11.3333 4.39997C11.1919 4.39997 11.0562 4.34378 10.9562 4.24376C10.8562 4.14374 10.8 4.00809 10.8 3.86664V1.9541L5.3109 7.44424C5.26131 7.49382 5.20245 7.53316 5.13766 7.55999C5.07287 7.58683 5.00343 7.60064 4.9333 7.60064C4.86317 7.60064 4.79373 7.58683 4.72895 7.55999C4.66416 7.53316 4.60529 7.49382 4.5557 7.44424C4.50611 7.39465 4.46678 7.33578 4.43994 7.27099C4.41311 7.2062 4.39929 7.13676 4.39929 7.06664C4.39929 6.99651 4.41311 6.92707 4.43994 6.86228C4.46678 6.79749 4.50611 6.73862 4.5557 6.68904L10.0458 1.19997H8.1333C7.99185 1.19997 7.8562 1.14378 7.75618 1.04376C7.65616 0.94374 7.59997 0.808085 7.59997 0.666636C7.59997 0.525187 7.65616 0.389532 7.75618 0.289512C7.8562 0.189493 7.99185 0.133303 8.1333 0.133303H11.3333C11.4034 0.133119 11.4728 0.146782 11.5376 0.173507C11.6024 0.200232 11.6613 0.239493 11.7109 0.289036Z" fill="black"/>
                                </svg>
                            </span>
                        </div>
                      </td>
                  } */}
                        <td>
                          <div>
                            <p>
                              {item.status === 1
                                ? "Live"
                                : item.status === 2
                                ? "Disabled"
                                : ""}
                            </p>
                          </div>
                        </td>
                      </tr>
                      )
                  
                })}
                </tbody>
              </table>

                 {/* Screen Modal */}
            {
                this.state.screenmodal ? 
                <div className="screener_popup">
                    <div className="screener_popup_innerpopup">
                        <div className="screener_popup_header text_center">
                            <h3 className="mb_10"> Screener Credentials</h3>
                            <p>{ScreenerPopupFilmTitle} </p>
                            <p>{moment(ScreenerPopupFilmData.date).tz("US/Mountain").format('MMM DD - h:mm A') + ' MT'} </p>
                        </div>
                        <div className="screener_popup_content">
                            <form>
                                <h3 className="mb_5">PIN</h3>
                                <h2 className="mb_15">{ScreenerPopupFilmData.screenerCredential.pin}</h2>
                                <div className="field_row">
                                    <div className="field_row_inner">
                                        <label>Password</label>
                                        <div className="field_input relative">
                                            <input
                                                type={this.state.showPass ? "text" : "password"}
                                                name="password"
                                                id="password"
                                                value={this.state.password}
                                                onChange={this.onInputChange}
                                            />
                                            <span className="eye_icon" onClick={this.Showpassword}> { this.state.showPass ? <ShowPasswordIcon />  : <ViewIcon /> } </span>
                                        </div>
                                        <span className='error srv-validation-message'>{this.state.passwordErr}</span>
                                    </div>
                                    
                                </div>
                                <div className="field_row pt_25">
                                    <button type='button' onClick={() => this.setState({screenmodal:false})}>CANCEL</button>
                                    <button className="active" type='button' onClick={()=>this.scannerSave(ScreenerPopupData,ScreenerPopupFilmData)}>SAVE</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                :
                ""       
            }

{
                this.state.addScreenerPopup ? 
                <div className="screener_popup " style={{maxWidth:"656px"}}>
                <div className="screener_popup_innerpopup p_0 screener_popup_filmlink_popup" >
                        <div className="popup_header dark_gray text_center relative">
                            <h3 className=""> Create Film Access Link</h3>
                            <span className="close_popup pointer" onClick={this.CloseModal}>
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.545654L5.94897 4.9225L1.70697 0.545654L0.292969 2.0046L4.53497 6.38145L0.292969 10.7583L1.70697 12.2173L5.94897 7.8404L10.192 12.2173L11.606 10.7583L7.36397 6.38145L11.606 2.0046L10.192 0.545654Z" fill="white"/>
                                </svg>
                            </span>
                        </div>
                    <div className="screener_popup_content text_center">
                        <form onSubmit={(e)=>this.setEmailGo(e)}>
                            <div className="field_row horizontal_field d_flex d_flex_align_baseline">
                                <TextField 
                                    placeholder="" 
                                    label="Email" 
                                    name='email' 
                                    value={this.state.email} 
                                    onChange={(e)=>this.onInputChange(e)}
                                    fpgerror={this.state.isExist === false ? "This user doesn’t exist in our database. Please try again" : ''}
                                    maxLength={255}/>
                                <button className="ml_25 active" style={{padding:"12px",minWidth:"76px"}} type='button' onClick={(e)=>this.setEmailGo(e)}>Go</button>
                            </div>
                            {this.state.isExist && this.state.userEmail?.email &&
                                <>
                                    <div className="mb_25">
                                        <p className="mb_5">The following user is found in our database</p>
                                        <p className="mb_5"><a href="javascript:;">{this.state.userEmail?.email}  </a> {this.state.userEmail?.fname} {this.state.userEmail?.lname} </p>
                                    </div>
                                    
                                    <div className="field_row mb_25">
                                        <button className="active uppercase" type='button' onClick={(e)=>this.setLink(e)}>Get Link</button>
                                    </div>
                                </>
                            }
                            <div className="field_row mb_25">
                                <p className="mb_25"><a href="javascript:;" className="d_block">{this.state.linkCopy}</a></p>
                                {this.state.linkCopy &&
                                    <button className="active uppercase" type='button' onClick={(e)=>this.copyLink(e,this.state.linkCopy)}>COPY Link</button>
                                }
                            </div>

                            {/* <div className="field_row mb_0">
                                <button className="active uppercase">COMMON Link</button>
                            </div> */}
                        </form>
                    </div>
                </div>
            </div>
                :
                ""
            }


               {/* ReactPaginate  */}
              {this.state.ShortProgramList &&
              this.state.ShortProgramList.length &&
              this.state.ShortProgramList ? (
                <div className="custom-pagination">
                  <ReactPaginate
                    previousLabel={""}
                    nextLabel={""}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    forcePage={this.state.currentPage}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
            
        )
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(shortProgramEpisodicList);